import { render } from "./DatasetCopyModal.vue?vue&type=template&id=2ef87249&scoped=true"
import script from "./DatasetCopyModal.vue?vue&type=script&lang=js"
export * from "./DatasetCopyModal.vue?vue&type=script&lang=js"

import "./DatasetCopyModal.vue?vue&type=style&index=0&id=2ef87249&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ef87249"]])

export default __exports__